import { PrimaryColor } from 'glints-aries';
import styled, { css } from 'styled-components';

export const DefaultBtnStyle = css`
  position: relative;
  display: flex;
  border: none;
  cursor: pointer;
`;

const DefaultBtn = styled.button`
  ${DefaultBtnStyle}
`;

export const GhostBtnStyle = css`
  ${DefaultBtnStyle}
  align-self: center;
  border: 2px solid ${PrimaryColor.glintsred};
`;

export const GhostBtn = styled(DefaultBtn)`
  ${GhostBtnStyle}
`;
